<template>
  <form action @submit.prevent="onRejectShippingRequest">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">Deny shipping application.</p>
      </header>

      <section class="modal-card-body">
        <div
          class="is-size-5 has-text-weight-bold has-margin-bottom-20"
        >Please confirm that you reviewed the shipping request, and wish to deny it.</div>
        <b-field>
          <b-input type="textarea" placeholder="Reason for rejection" v-model="rejectionMessage"></b-input>
        </b-field>
        <b-checkbox class="has-margin-top-20" required>I have reviewed the shipping request.</b-checkbox>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">Close</button>
        <button class="button is-primary">Deny Application</button>
      </footer>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    rejectShippingRequest: { type: Function, required: true },
    shippingRequest: { type: Object, required: true }
  },

  data() {
    return {
      rejectionMessage: ""
    };
  },

  methods: {
    onRejectShippingRequest() {
      this.rejectShippingRequest(this.shippingRequest, this.rejectionMessage);
      this.$parent.close();
    }
  }
};
</script>
